import React, { useEffect } from "react"

import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin"
import { MotionPathPlugin } from "gsap/MotionPathPlugin"

const TempStyleBlock = () => {
  return (
    <style suppressHydrationWarning>
      {`
        .info-graphic {
          padding: 5rem 0;
          display: flex;
          justify-content: center;
          flex-direction: column;
          align-items: center;
          transform: scale(1.3);
          padding-bottom: 10rem;
        }
        @media (min-width: 550px) {
          .info-graphic {
            transform: scale(1.4);
          }
        }
        @media (min-width: 768px) {
          .info-graphic {
            transform: scale(1.3);
          }
        }
        @media (min-width: 1024px) {
          .info-graphic {
            transform: scale(1.2);
          }
        }
        @media (min-width: 1920px) {
          .info-graphic {
            transform: scale(1);
          }
        }

        .info-graphic-wrapper {
          width: 100vw;
        }

        @media (min-width: 1280px) {
          .info-graphic-wrapper {
            width: 75vw;
          }
        }


        .svg-container {
          display: block;
          position: relative;
          width: 100%;
        }
        .svg-container:before {
          content: "";
          display: block;
          padding-top: 71%;
        }

        .svg-content {
          display: inline-block;
          position: absolute;
          top: 0;
          left: 0;
          transform-origin: 50% 50%;
        }

        .space-center-item {
          /*filter: drop-shadow( 0px 0px 80px rgba(255, 255, 255, .6));*/
          transform-origin: 50% 50%;
          width: 200px;
          height: 200px;
        }
        .space-center-item .circle {
          background-color: #1226a8;
          border-radius: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 1rem;
          width: 100%;
          height: 100%;
        }
        .space-center-item .circle img {
          width: 100%;
        }

        .orbit-path {
          stroke-linecap: square;
          stroke: rgba(255,255,255,1.0);
          transform-origin: 50% 50%;
          /* todo: stroke-dasharray: 10; */
        }


        .orbit-services-path {
          stroke-width: 2px;
          opacity: 0;
          /*stroke: rgba(232,108,61,0.8);*/
        }

        .orbit-data-path {
          stroke-width: 2px;
          /*stroke: rgba(76,148,166,0.8);*/
        }

        .orbit-features-path {
          stroke-width: 2px;
          opacity: 0;
        }

        .orbit-decoration-path {
          stroke-width: 2px;
          opacity: 0;
        }

        .orbit-services {
          transform-origin: 50% 50%;
          transform: scale(1.6);
          /*filter: drop-shadow( 0px 0px 5px rgba(255, 255, 255, 1.0))*/
        }

        .orbit-features {
          transform-origin: 50% 50%;
          transform: scale(1.22);
          /*filter: drop-shadow( 0px 0px 5px rgba(255, 255, 255, 1.0))*/
        }


        .orbit-features-labels {
          transform-origin: 50% 50%;
          /*transform: scale(1.20) rotateZ(-20deg);*/
          opacity: 0;
        }

        .orbit-features-item1-label-g {
          transform-origin: 50% 50%;
          transform: rotateZ(0deg);
        }
        .orbit-features-item2-label-g {
          transform-origin: 50% 50%;
          transform: rotateZ(120deg);
        }
        .orbit-features-item3-label-g {
          transform-origin: 50% 50%;
          transform: rotateZ(-78deg);
        }

        .orbit-features-fragment {
          fill: none;
          stroke: #fff;
          stroke-width: 5px;
          transform-origin: 50% 50%;
          transform: scale(0.51);
          stroke-dasharray: 235,71428571 1571.42857143; /* 15% > 54deg */
        }

        .orbit-features-fragment-1 {
          transform: scale(0.51) rotateZ(120deg);
        }
        .orbit-features-fragment-2 {
          transform: scale(0.51) rotateZ(242deg);
        }
        .orbit-features-fragment-3 {
          transform: scale(0.51) rotateZ(0deg);
        }


        .orbit-data {
          transform-origin: 50% 50%;
          transform: rotateX(65deg) rotateY(30deg) scale(1.9);
          /*filter: drop-shadow( 0px 0px 5px rgba(255, 255, 255, 1.0))*/
        }

        .orbit-decoration {
          transform-origin: 50% 50%;
          transform: rotateZ(140deg) rotateX(69deg) rotateY(15deg) scale(1);
          /*filter: drop-shadow( 0px 0px 5px rgba(255, 255, 255, 1.0))*/
        }

        .orbit-label {
          font-size: 1rem;
          fill: #fff;
          opacity: 0;
        }
        .orbit-label-primary {
          font-family: 'Brother1816';
          font-weight: 700;
        }

        .orbit-label-secondary {
          font-family: 'Inter';
          font-weight: 100;
          font-size: 0.8rem;
          transform-origin: 50% 50%;
        }

        .orbit-item {
          opacity: 0;
          transform: scale(0.18);
          /*filter: drop-shadow( 0px 0px 220px rgba(255, 255, 255, 1.0));*/
          transform-origin: 50% 50%;
        }

      `}
    </style>
  )
}


const Orbit = ({ block }) => {
  const hasServiceItem = (block.service_orbit_item_text_1 !== "" || block.service_orbit_item_text_2 !== ""  || block.service_orbit_item_text_3 !== "" || block.service_orbit_item_text_4 !== "" )

  useEffect(() => {
    var clientWidth = (window.innerWidth > 0) ? window.innerWidth : window.screen.width
    window.setTimeout(function () {
      gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin, MotionPathPlugin)
      let tl = gsap.timeline()
      let graphicHeight = document.querySelector('.info-graphic').offsetHeight
      let orbitsMovementEnding = Math.floor(graphicHeight * 0.3).toString() + "px center";
      let orbitItemsMovementEnding = Math.floor(graphicHeight * 0.3).toString() + "px center";
      let featureItemsMovementEnding = Math.floor(graphicHeight * 0.3).toString() + "px center";
      let decorationMovementEnding = Math.floor(graphicHeight * 0.8).toString() + "px center";

      let serviceItemPositions = {
        item1: {
          start: 0.01,
          end: 0.2
        },
        item2: {
          start: 0.3,
          end: 0.6
        },
        item3: {
          start: 0.4,
          end: 0.9
        }
      }
      let dataItemPositions = {
        item1: {
          start: 0.1,
          end: 0.23
        },
        item2: {
          start: 0.1,
          end: 0.5
        },
        item3: {
          start: -0.9,
          end: 0.09
        }
      }
      let panningDistance = clientWidth / 2

      if (clientWidth <= 768) {
        let zoom_tl = gsap.timeline()
        .to(".svg-content", { duration: 200, scale: 2.0, transformOrigin: "50% 50%", force3D: false }, "zoom-in")
        .to(".svg-content", { duration: 200, translateX: -panningDistance, transformOrigin: "50% 50%", force3D: false }, "pan-east")
        .to(".svg-content", { duration: 200, translateX: panningDistance, transformOrigin: "50% 50%", force3D: false }, "pan-west")
        .to(".svg-content", { duration: 200, scale: 1.0, translateX: 0, translateY: 0, transformOrigin: "50% 50%", force3D: false }, "reset-pan-zoom-out");
        ScrollTrigger.create({
          animation: zoom_tl,
          trigger: ".info-graphic",
          pin: true,
          start: () => "top 80px",
          end: () => "bottom top",
          scrub: 0.5,
          toggleActions: "play none none reset",
          invalidateOnRefresh: true,
        });

      }

      if (hasServiceItem) {
        tl.fromTo(".orbit-services-path", { opacity: 0, drawSVG: "0%", strokeWidth: 1 }, { opacity: 1, drawSVG: "100%", strokeWidth: 2, strokeDasharray: "40", scrollTrigger: {
          trigger: ".svg-container",
          start: "-220px center",
          end: orbitsMovementEnding,
          toggleActions: "play none none reset",
          scrub: 1.4,
        }}, 0);
      }

      tl.from(".orbit-data-path", { opacity: 1, drawSVG: "0%", strokeWidth: 1, scrollTrigger: {
        trigger: ".svg-container",
        start: "-120px center",
        end: orbitsMovementEnding,
        toggleActions: "play none none reset",
        scrub: 1.4,
      }}, 0);

      tl.fromTo(".orbit-decoration-path", { opacity: 0, drawSVG: "10%", strokeWidth: 1}, { opacity: 1, drawSVG: "80%", strokeWidth: 2, scrollTrigger: {
        trigger: ".svg-container",
        start: "-120px center",
        end: decorationMovementEnding,
        toggleActions: "play none none reset",
        scrub: 1.4,
      }}, 0);


      tl.fromTo(".space-center-item", { opacity: 0.5, scale: 0.1, transformOrigin: "50% 50%"}, { opacity: 1, scale: 0.7, ease: "elastic(1.25, 1)", transformOrigin: "50% 50%", scrollTrigger: {
        trigger: ".svg-container",
        start: "-220px center",
        end: "200px 200px",
        toggleActions: "play none none reset",
        scrub: 1.4,
      }}, 0);

      tl.to(".orbit-services-item1", {opacity: 1, motionPath: { path: ".orbit-services-path", align:".orbit-services-path", start: serviceItemPositions.item1.start, end: serviceItemPositions.item1.end, alignOrigin: [0.5, 0.5]}, scrollTrigger: {
        trigger: ".svg-container",
        start: "-20px center",
        end: orbitItemsMovementEnding,
        toggleActions: "play none none reset",
        scrub: 1.1,
      }}, 0);

      tl.to(".orbit-services-item1-label", {opacity: 1, motionPath: { path: ".orbit-services-path", align:".orbit-services-path", start: serviceItemPositions.item1.start, end: serviceItemPositions.item1.end, alignOrigin: [1.2, 0.6], offsetX: -10}, scrollTrigger: {
        trigger: ".svg-container",
        start: "-20px center",
        end: orbitItemsMovementEnding,
        toggleActions: "play none none reset",
        scrub: 1.1,
      }}, 0);

      tl.to(".orbit-services-item2", {opacity: 1, motionPath: { path: ".orbit-services-path", align:".orbit-services-path", start: serviceItemPositions.item2.start, end: serviceItemPositions.item2.end, alignOrigin: [0.5, 0.5]}, scrollTrigger: {
        trigger: ".svg-container",
        start: "-20px center",
        end: orbitItemsMovementEnding,
        toggleActions: "play none none reset",
        scrub: 1.1,
      }}, 0);
      tl.to(".orbit-services-item2-label", {opacity: 1, motionPath: { path: ".orbit-services-path", align:".orbit-services-path", start: serviceItemPositions.item2.start, end: serviceItemPositions.item2.end, alignOrigin: [-0.2, 0.5], offsetX: 30}, scrollTrigger: {
        trigger: ".svg-container",
        start: "-20px center",
        end: orbitItemsMovementEnding,
        toggleActions: "play none none reset",
        scrub: 1.1,
      }}, 0);

      tl.to(".orbit-services-item3", {opacity: 1, motionPath: { path: ".orbit-services-path", align:".orbit-services-path", start: serviceItemPositions.item3.start, end: serviceItemPositions.item3.end, alignOrigin: [0.5, 0.5]}, scrollTrigger: {
        trigger: ".svg-container",
        start: "-20px center",
        end: orbitItemsMovementEnding,
        toggleActions: "play none none reset",
        scrub: 1.1,
      }}, 0);
      tl.to(".orbit-services-item3-label", {opacity: 1, motionPath: { path: ".orbit-services-path", align:".orbit-services-path", start: serviceItemPositions.item3.start, end: serviceItemPositions.item3.end, alignOrigin: [1.2, 0.6], offsetX: -10}, scrollTrigger: {
        trigger: ".svg-container",
        start: "-20px center",
        end: orbitItemsMovementEnding,
        toggleActions: "play none none reset",
        scrub: 1.1,
      }}, 0);

      tl.to(".orbit-data-item1", {opacity: 1, motionPath: { path: ".orbit-data-path", align:".orbit-data-path", start: dataItemPositions.item1.start, end: dataItemPositions.item1.end, alignOrigin: [0.5, 0.5]}, scrollTrigger: {
        trigger: ".svg-container",
        start: "-20px center",
        end: orbitItemsMovementEnding,
        toggleActions: "play none none reset",
        scrub: 1.1,
      }}, 0);

      tl.to(".orbit-data-item1-label", {opacity: 1, motionPath: { path: ".orbit-data-path", align:".orbit-data-path", start: dataItemPositions.item1.start, end: dataItemPositions.item1.end, alignOrigin: [0.0, 0.5], offsetX: 30}, scrollTrigger: {
        trigger: ".svg-container",
        start: "-20px center",
        end: orbitItemsMovementEnding,
        toggleActions: "play none none reset",
        scrub: 1.1,
      }}, 0);

      tl.to(".orbit-data-item2", {opacity: 1, motionPath: { path: ".orbit-data-path", align:".orbit-data-path", start: dataItemPositions.item2.start, end: dataItemPositions.item2.end, alignOrigin: [0.5, 0.5]}, scrollTrigger: {
        trigger: ".svg-container",
        start: "-20px center",
        end: orbitItemsMovementEnding,
        toggleActions: "play none none reset",
        scrub: 1.1,
      }}, 0);

      tl.to(".orbit-data-item2-label", {opacity: 1, motionPath: { path: ".orbit-data-path", align:".orbit-data-path", start: dataItemPositions.item2.start, end: dataItemPositions.item2.end, alignOrigin: [0.0, 0.5], offsetX: 30}, scrollTrigger: {
        trigger: ".svg-container",
        start: "-20px center",
        end: orbitItemsMovementEnding,
        toggleActions: "play none none reset",
        scrub: 1.1,
      }}, 0);

      tl.to(".orbit-data-item3", {opacity: 1, motionPath: { path: ".orbit-data-path", align:".orbit-data-path", start: dataItemPositions.item3.start, end: dataItemPositions.item3.end, alignOrigin: [0.5, 0.5]}, scrollTrigger: {
        trigger: ".svg-container",
        start: "-20px center",
        end: orbitItemsMovementEnding,
        toggleActions: "play none none reset",
        scrub: 1.1,
      }}, 0);

      tl.to(".orbit-data-item3-label", {opacity: 1, motionPath: { path: ".orbit-data-path", align:".orbit-data-path", start: dataItemPositions.item3.start, end: dataItemPositions.item3.end, alignOrigin: [1.1, 0.6], offsetX: -28}, scrollTrigger: {
        trigger: ".svg-container",
        start: "-20px center",
        end: orbitItemsMovementEnding,
        toggleActions: "play none none reset",
        scrub: 1.1,
      }}, 0);



      tl.to(".orbit-features-item1", {opacity: 1, motionPath: { path: ".orbit-features-path", align:".orbit-features-path", start: 0.00, end: 0.90, alignOrigin: [0.5, 0.5]}, scrollTrigger: {
        trigger: ".svg-container",
        start: "-20px center",
        end: featureItemsMovementEnding,
        toggleActions: "play none none reset",
        scrub: 1.1,
      }}, 0);

      tl.to(".orbit-features-item2", {opacity: 1, motionPath: { path: ".orbit-features-path", align:".orbit-features-path", start: 0.00, end: 0.235, alignOrigin: [0.5, 0.5]}, scrollTrigger: {
        trigger: ".svg-container",
        start: "-20px center",
        end: featureItemsMovementEnding,
        toggleActions: "play none none reset",
        scrub: 1.1,
      }}, 0);

      tl.to(".orbit-features-item3", {opacity: 1, motionPath: { path: ".orbit-features-path", align:".orbit-features-path", start: 0.00, end: 0.57, alignOrigin: [0.5, 0.5]}, scrollTrigger: {
        trigger: ".svg-container",
        start: "-20px center",
        end: featureItemsMovementEnding,
        toggleActions: "play none none reset",
        scrub: 1.1,
      }}, 0);

      tl.fromTo(".orbit-features-labels",{ opacity: 0.0, rotation: -90, scale: 1.20,  transformOrigin: "center"}, { opacity: 1, rotation: -30, scale: 1.20, transformOrigin: "center", scrollTrigger: {
        trigger: ".svg-container",
        start: "-220px center",
        end: featureItemsMovementEnding,
        toggleActions: "play none none reset",
        scrub: 1.1,
      }}, 0);

    }, 1000)
  }, [])

  return (
    <div className="info-graphic">
      <TempStyleBlock />
      <div className="info-graphic-wrapper">
          <div className="svg-container">
            <svg className="svg-content svg-orbiting" viewBox="0 0 1400 1000" xmlns="http://www.w3.org/2000/svg">

              <defs>
                <symbol id="mm-office-logo" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg"><circle cx="25" cy="25" r="25" fill="#1226a8"/><g fill="#fff"><path d="M25.622 23.33c1.376 0 2.42 1.11 2.42 2.475 0 1.388-1.044 2.476-2.42 2.476-1.388 0-2.42-1.088-2.42-2.476-.012-1.365 1.032-2.476 2.42-2.476zm0 4.595c1.187 0 2.02-.92 2.02-2.12 0-1.188-.833-2.12-2.02-2.12-1.188 0-2.032.932-2.032 2.12 0 1.2.844 2.12 2.032 2.12zm4.118-4.185v1.887h1.954v.322H29.74v2.254h-.388v-4.796h2.708v.322h-2.32zm3.941 0v1.887h1.954v.322h-1.954v2.254h-.388v-4.796h2.709v.322h-2.32zm3.542 4.463v-4.796h.388v4.796h-.388zm5.662-4.13c-.378-.189-.889-.388-1.466-.388-1.232 0-2.098.932-2.098 2.12 0 1.188.866 2.12 2.098 2.12.6 0 1.121-.188 1.51-.377v.377c-.3.156-.822.356-1.51.356-1.42 0-2.487-1.088-2.487-2.476 0-1.377 1.066-2.476 2.487-2.476.666 0 1.177.211 1.466.367v.377zm1.254 4.13v-4.796h2.842v.322h-2.453v1.876h2.087v.322h-2.087v1.943h2.553v.322h-2.942zM14.809 24.417h-1.232V21.12h-.078l-1.221 1.443v1.854H11.1c-.222 0-.455-.01-.655-.033-.4-.133-.655-.489-.655-1.01 0-.722.488-1.166 1.254-1.166h.444V21.12h-.366c-1.587 0-2.72.766-2.72 2.154 0 .7.41 1.276.977 1.532-.71.244-1.265.977-1.265 1.843 0 1.398 1.12 2.231 2.764 2.231h2.698v-3.497h1.232v-.966zm-2.531.966v2.398h-1.455c-.777 0-1.32-.466-1.32-1.21 0-.766.499-1.2 1.176-1.2h1.599z"/><path d="M11.456 33.543c-4.707 0-8.537-3.841-8.537-8.549s3.83-8.537 8.537-8.537 8.537 3.83 8.537 8.537-3.83 8.549-8.537 8.549zm0-15.976c-4.096 0-7.427 3.33-7.427 7.427s3.33 7.427 7.427 7.427 7.427-3.33 7.427-7.427-3.33-7.427-7.427-7.427z"/></g></symbol>

                <symbol id="mm-office_vr-logo" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg"><circle cx="25" cy="25" r="25" fill="#1226a8"/><g transform="translate(-222.754 -132.667) scale(.31446)"><path d="M776.6 494.66c3.47 0 6.1 2.8 6.1 6.24 0 3.5-2.63 6.24-6.1 6.24-3.5 0-6.1-2.74-6.1-6.24.01-3.44 2.61-6.24 6.1-6.24zm0 11.58c2.99 0 5.09-2.32 5.09-5.34 0-2.99-2.1-5.34-5.09-5.34-2.99 0-5.12 2.35-5.12 5.34.01 3.02 2.13 5.34 5.12 5.34zM787.01 495.7v4.75h4.92v.81h-4.92v5.68h-.98v-12.08h6.82v.81h-5.84v.03zM796.91 495.7v4.75h4.92v.81h-4.92v5.68h-.98v-12.08h6.82v.81h-5.84v.03zM805.86 506.94v-12.08h.98v12.08h-.98zM820.12 496.54c-.95-.48-2.24-.98-3.69-.98-3.1 0-5.29 2.35-5.29 5.34s2.18 5.34 5.29 5.34c1.51 0 2.82-.48 3.8-.95v.95c-.76.39-2.07.89-3.8.89-3.58 0-6.26-2.74-6.26-6.24 0-3.47 2.68-6.24 6.26-6.24 1.68 0 2.96.53 3.69.92v.97zM823.28 506.94v-12.08h7.16v.81h-6.18v4.73h5.26v.81h-5.26v4.89h6.43v.81h-7.41v.03zM841.21 507.14h-.03l-5.29-12.28h1.03l2.88 6.8c.48 1.15.95 2.18 1.4 3.27.45-1.12.89-2.13 1.4-3.27l2.85-6.8h1.06l-5.3 12.28zM852.67 494.86c2.49 0 4 1.31 4 3.5 0 1.82-1.12 3.05-2.8 3.38l2.91 5.2h-1.06l-2.82-5.09h-2.99v5.09h-.98v-12.08h3.74zm-2.77.84v5.37h2.77c1.9 0 2.99-1.03 2.99-2.68 0-1.68-1.12-2.68-3.05-2.68h-2.71z" fill="#fff"/><path d="M749.39 499.44h-3.1v-8.31h-.2l-3.08 3.64v4.67h-2.96c-.56 0-1.15-.03-1.65-.08-1.01-.34-1.65-1.23-1.65-2.54 0-1.82 1.23-2.94 3.16-2.94h1.12v-2.74h-.92c-4 0-6.85 1.93-6.85 5.43 0 1.76 1.03 3.22 2.46 3.86-1.79.62-3.19 2.46-3.19 4.64 0 3.52 2.82 5.62 6.96 5.62h6.8v-8.81h3.1v-2.44zm-6.37 2.44v6.04h-3.66c-1.96 0-3.33-1.17-3.33-3.05 0-1.93 1.26-3.02 2.96-3.02h4.03v.03z" fill="#fff"/><path d="M740.95 522.41c-11.86 0-21.51-9.65-21.51-21.51s9.65-21.51 21.51-21.51c11.86 0 21.51 9.65 21.51 21.51s-9.65 21.51-21.51 21.51zm0-40.22c-10.32 0-18.71 8.39-18.71 18.71s8.39 18.71 18.71 18.71 18.71-8.39 18.71-18.71-8.39-18.71-18.71-18.71z" fill="#fff" /></g></symbol>

                <symbol id="mm-inswot-logo" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg"><circle cx="25" cy="25" r="25" fill="#1226a8"/><g transform="matrix(.8796 0 0 .8796 2.79 18.083)"><path d="M18.89 6.7V2.38h.35V6.7h-.35zM21.21 3.36c-.04-.05-.1-.11-.12-.15.01.07.01.16.01.28V6.7h-.35V2.31h.01l2.82 3.41c.04.05.1.11.12.15-.01-.07-.01-.16-.01-.28v-3.2h.34v4.38h-.01l-2.81-3.41zM25.18 6.52v-.36c.27.13.7.29 1.19.29.58 0 1.04-.28 1.04-.75s-.23-.73-1.03-1.01c-.89-.32-1.21-.7-1.21-1.29 0-.7.61-1.09 1.34-1.09.43 0 .8.12 1.03.23v.34c-.23-.11-.64-.25-1.02-.25-.58 0-1 .29-1 .75 0 .42.2.71 1.01 1.01.89.32 1.22.67 1.22 1.29 0 .69-.59 1.09-1.38 1.09-.49 0-.92-.13-1.19-.25zM28.7 2.38l.91 2.55.32.92c.1-.29.21-.58.33-.9l.91-2.51h.01l.92 2.51.33.9c.1-.29.21-.6.32-.92l.91-2.55h.37l-1.6 4.39h-.01L31.77 5l-.59-1.63c-.19.54-.38 1.09-.58 1.63l-.65 1.78h-.01l-1.6-4.39h.36zM36.86 2.31c1.24 0 2.18 1 2.18 2.23 0 1.25-.94 2.23-2.18 2.23-1.25 0-2.18-.98-2.18-2.23-.01-1.23.93-2.23 2.18-2.23zm0 4.14c1.07 0 1.82-.83 1.82-1.91 0-1.07-.75-1.91-1.82-1.91s-1.83.84-1.83 1.91c0 1.08.76 1.91 1.83 1.91zM41.4 2.68V6.7h-.34V2.68h-1.34v-.3h3.04v.29H41.4zM20.2 8.61h.01L22.15 13h-.37l-.49-1.12h-2.17L18.63 13h-.37l1.94-4.39zm.96 2.98c-.33-.76-.64-1.48-.95-2.22-.32.75-.63 1.47-.96 2.22h1.91zM23.52 9.66c-.04-.05-.1-.11-.12-.15.01.07.01.16.01.28V13h-.35V8.61h.01l2.82 3.41c.04.05.1.11.12.15-.01-.06-.01-.16-.01-.27V8.69h.34v4.38h-.01l-2.81-3.41zM29.21 8.61h.01L31.15 13h-.37l-.49-1.12h-2.17L27.64 13h-.37l1.94-4.39zm.96 2.98c-.33-.76-.64-1.48-.95-2.22-.32.75-.64 1.47-.97 2.22h1.92zM32.07 13V8.68h.35v4.02h1.94v.3h-2.29zM34.79 8.68l1.38 2.24 1.38-2.24h.39l-1.6 2.58V13H36v-1.74l-1.6-2.58h.39zM40.91 8.98h-2.36v-.3h2.9l-2.49 4.02h2.53v.3h-3.07l2.49-4.02zM42.62 13V8.68h2.56v.29h-2.21v1.69h1.88v.29h-1.88v1.75h2.3v.3h-2.65zM47.74 8.68c.89 0 1.43.47 1.43 1.25 0 .65-.4 1.09-1 1.21L49.21 13h-.38l-1.01-1.82h-1.07V13h-.35V8.68h1.34zm-.99.3v1.92h.99c.68 0 1.07-.37 1.07-.96 0-.6-.4-.96-1.09-.96h-.97z" fill="#fff"/><g><path d="M10.71 7.17H9.6V4.2h-.07l-1.1 1.3v1.67H7.37c-.2 0-.41-.01-.59-.03-.36-.12-.59-.44-.59-.91 0-.65.44-1.05 1.13-1.05h.4V4.2h-.33c-1.43 0-2.45.69-2.45 1.94 0 .63.37 1.15.88 1.38-.64.22-1.14.88-1.14 1.66 0 1.26 1.01 2.01 2.49 2.01H9.6V8.04h1.11v-.87zm-2.28.87v2.16H7.12c-.7 0-1.19-.42-1.19-1.09 0-.69.45-1.08 1.06-1.08h1.44z" fill="#fff"/><path d="M7.69 15.38C3.45 15.38 0 11.93 0 7.69S3.45 0 7.69 0s7.69 3.45 7.69 7.69-3.45 7.69-7.69 7.69zM7.69 1C4 1 1 4 1 7.69s3 6.69 6.69 6.69 6.69-3 6.69-6.69S11.38 1 7.69 1z" fill="#fff"/></g></g></symbol>

                <symbol id="mm-nq-logo" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg"><circle cx="25" cy="25" r="25" fill="#1226a8"/><g ><g><path d="M10.96 25.562h-.817v-2.188h-.052l-.81.958v1.23H8.5c-.147 0-.302-.007-.435-.022-.265-.088-.434-.324-.434-.67 0-.48.324-.774.832-.774h.295v-.722h-.243c-1.054 0-1.805.508-1.805 1.43 0 .464.272.847.648 1.016-.472.162-.84.648-.84 1.216 0 .928.744 1.48 1.835 1.48h1.79v-2.313h.818v-.64zm-1.68.641v1.591h-.964c-.516 0-.877-.309-.877-.803 0-.508.332-.795.781-.795h1.06z" fill="#fff"/><path d="M8.736 31.61c-3.124 0-5.666-2.541-5.666-5.665s2.542-5.665 5.666-5.665 5.665 2.542 5.665 5.665-2.542 5.666-5.665 5.666zm0-10.593c-2.719 0-4.929 2.21-4.929 4.928s2.21 4.929 4.929 4.929 4.928-2.21 4.928-4.929-2.21-4.928-4.928-4.928z" fill="#fff"/></g><g><path d="M16.847 22.1l.715 1.996.25.715c.081-.229.162-.457.258-.7l.715-1.967h.007l.715 1.967.257.7c.074-.229.163-.472.25-.715l.716-1.996h.287l-1.253 3.433h-.007l-.508-1.385-.464-1.275c-.148.42-.302.855-.457 1.275l-.509 1.385h-.007L16.56 22.1h.287zM21.79 25.481V22.1h2.004v.228h-1.731v1.326h1.473v.228h-1.473v1.363h1.798v.229h-2.07zM26.948 24.553c0 .575-.45.92-1.025.92h-1.17V22.1h1.03c.627 0 1.01.368 1.01.898 0 .332-.177.59-.42.7.28.118.575.413.575.855zm-.855-.928c.228-.06.42-.266.42-.612 0-.435-.28-.692-.744-.692h-.752v1.296h1.076zm-1.076 1.628h.87c.45 0 .78-.273.78-.715 0-.405-.294-.692-.655-.692h-.987v1.407zM27.728 25.334v-.28c.214.096.546.228.936.228.457 0 .81-.213.81-.59 0-.367-.176-.566-.803-.795-.692-.25-.943-.545-.943-1.01 0-.544.48-.846 1.047-.846.331 0 .626.095.803.176v.273c-.185-.081-.501-.199-.796-.199-.45 0-.78.229-.78.59 0 .331.161.56.795.788.7.25.95.523.95 1.01 0 .537-.457.854-1.076.854-.39 0-.729-.103-.943-.2zM30.616 25.481V22.1h2.004v.228H30.89v1.326h1.473v.228H30.89v1.363h1.798v.229h-2.07zM34.617 22.1c.692 0 1.12.368 1.12.98 0 .508-.31.847-.781.942l.818 1.452h-.303l-.788-1.422h-.832v1.422h-.273V22.1h1.039zm-.774.228v1.503h.774c.53 0 .84-.287.84-.752 0-.471-.317-.751-.848-.751h-.766zM37.578 25.533h-.007L36.098 22.1h.287l.803 1.9c.133.325.265.612.39.921.126-.31.251-.596.391-.92l.796-1.901h.294l-1.48 3.433zM39.73 25.481V22.1h.272v3.374h-.272zM43.723 22.571c-.265-.133-.626-.272-1.039-.272-.87 0-1.48.655-1.48 1.488 0 .84.61 1.488 1.48 1.488.427 0 .796-.133 1.06-.265v.265c-.213.11-.574.25-1.06.25a1.72 1.72 0 01-1.753-1.746c0-.972.751-1.746 1.753-1.746.472 0 .833.148 1.039.258v.28zM44.6 25.481V22.1h2.003v.228h-1.73v1.326h1.473v.228h-1.474v1.363h1.798v.229H44.6zM17.326 27.308c-.03-.037-.074-.08-.096-.118.007.06.007.126.007.214v2.512h-.272V26.49h.007l2.203 2.667c.03.045.074.089.096.118-.008-.051-.008-.125-.008-.213v-2.513h.266v3.426h-.008l-2.195-2.667zM22.188 26.49c.973 0 1.71.781 1.71 1.747 0 .898-.627 1.628-1.489 1.73.428.362 1.01.627 1.555.627.155 0 .317-.022.434-.044v.25c-.11.03-.28.052-.456.052-.627 0-1.349-.354-1.879-.87-.92-.073-1.584-.817-1.584-1.745 0-.966.73-1.747 1.71-1.747zm0 3.235c.84 0 1.43-.649 1.43-1.488 0-.833-.59-1.489-1.43-1.489-.832 0-1.429.656-1.429 1.489 0 .832.59 1.488 1.43 1.488z" fill="#fff"/></g></g></symbol>

                <symbol id="mm-volatium-logo" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg"><circle cx="25" cy="25" r="25" fill="#1226a8"/><g transform="matrix(.73673 0 0 .73673 -22.934 -14.874)"><path d="M45.912 54.886h-1.11v-2.97h-.07l-1.1 1.3v1.67h-1.06c-.2 0-.41-.01-.59-.03-.36-.12-.59-.44-.59-.91 0-.65.44-1.05 1.13-1.05h.4v-.98h-.33c-1.43 0-2.45.69-2.45 1.94 0 .63.37 1.15.88 1.38-.64.22-1.14.88-1.14 1.65 0 1.26 1.01 2.01 2.49 2.01h2.43v-3.14h1.11v-.87zm-2.28.87v2.16h-1.31c-.7 0-1.19-.42-1.19-1.09 0-.69.45-1.08 1.06-1.08h1.44z" fill="#fff"/><path d="M42.892 63.096c-4.24 0-7.69-3.45-7.69-7.69s3.45-7.69 7.69-7.69 7.69 3.45 7.69 7.69-3.45 7.69-7.69 7.69zm0-14.38c-3.69 0-6.69 3-6.69 6.69s3 6.69 6.69 6.69 6.69-3 6.69-6.69-3-6.69-6.69-6.69z" fill="#fff"/><g><path d="M53.902 50.186l.97 2.71.34.97c.11-.31.22-.62.35-.95l.97-2.67h.01l.97 2.67.35.95c.1-.31.22-.64.34-.97l.97-2.71h.39l-1.7 4.66h-.01l-.69-1.88-.63-1.73c-.2.57-.41 1.16-.62 1.73l-.69 1.88h-.01l-1.7-4.66h.39zM60.612 54.776v-4.59h2.72v.31h-2.35v1.8h2v.31h-2v1.85h2.44v.31h-2.81zM67.612 53.516c0 .78-.61 1.25-1.39 1.25h-1.59v-4.58h1.4c.85 0 1.37.5 1.37 1.22 0 .45-.24.8-.57.95.38.16.78.56.78 1.16zm-1.16-1.26c.31-.08.57-.36.57-.83 0-.59-.38-.94-1.01-.94h-1.02v1.76h1.46zm-1.46 2.21h1.18c.61 0 1.06-.37 1.06-.97 0-.55-.4-.94-.89-.94h-1.34v1.91zM68.672 54.576v-.38c.29.13.74.31 1.27.31.62 0 1.1-.29 1.1-.8 0-.5-.24-.77-1.09-1.08-.94-.34-1.28-.74-1.28-1.37 0-.74.65-1.15 1.42-1.15.45 0 .85.13 1.09.24v.37c-.25-.11-.68-.27-1.08-.27-.61 0-1.06.31-1.06.8 0 .45.22.76 1.08 1.07.95.34 1.29.71 1.29 1.37 0 .73-.62 1.16-1.46 1.16-.53 0-.99-.14-1.28-.27zM72.592 54.776v-4.59h2.72v.31h-2.35v1.8h2v.31h-2v1.85h2.44v.31h-2.81zM78.022 50.186c.94 0 1.52.5 1.52 1.33 0 .69-.42 1.15-1.06 1.28l1.11 1.97h-.41l-1.07-1.93h-1.13v1.93h-.37v-4.58h1.41zm-1.05.31v2.04h1.05c.72 0 1.14-.39 1.14-1.02 0-.64-.43-1.02-1.15-1.02h-1.04zM82.042 54.846h-.01l-2-4.66h.39l1.09 2.58c.18.44.36.83.53 1.25.17-.42.34-.81.53-1.25l1.08-2.58h.4l-2.01 4.66zM84.962 54.776v-4.59h.37v4.58h-.37zM90.382 50.826c-.36-.18-.85-.37-1.41-.37-1.18 0-2.01.89-2.01 2.02 0 1.14.83 2.02 2.01 2.02.58 0 1.08-.18 1.44-.36v.36c-.29.15-.78.34-1.44.34-1.36 0-2.38-1.04-2.38-2.37 0-1.32 1.02-2.37 2.38-2.37.64 0 1.13.2 1.41.35v.38zM91.572 54.776v-4.59h2.72v.31h-2.35v1.8h2v.31h-2v1.85h2.44v.31h-2.81z" fill="#fff"/><g><path d="M56.452 60.896h-.01l-2.05-4.76h.4l1.11 2.64c.19.45.36.84.54 1.27.17-.43.34-.83.54-1.27l1.11-2.64h.41l-2.05 4.76zM61.382 56.066c1.35 0 2.37 1.08 2.37 2.42 0 1.35-1.01 2.42-2.37 2.42-1.35 0-2.37-1.07-2.37-2.42.01-1.34 1.02-2.42 2.37-2.42zm0 4.48c1.16 0 1.98-.9 1.98-2.07 0-1.16-.81-2.07-1.98-2.07-1.16 0-1.98.91-1.98 2.07 0 1.17.83 2.07 1.98 2.07zM65.032 60.826v-4.68h.38v4.36h2.11v.32h-2.49zM70.052 56.066h.01l2.09 4.76h-.4l-.53-1.22h-2.35l-.53 1.22h-.4l2.11-4.76zm1.04 3.22c-.36-.82-.7-1.6-1.03-2.41-.34.81-.69 1.59-1.05 2.41h2.08zM73.982 56.466v4.36h-.37v-4.36h-1.46v-.32h3.29v.32h-1.46zM76.502 60.826v-4.68h.38v4.68h-.38zM81.812 59.236c0 1.05-.64 1.66-1.7 1.66-1.07 0-1.71-.62-1.71-1.66v-3.09h.38v3.08c0 .83.5 1.33 1.33 1.33s1.33-.49 1.33-1.33v-3.08h.37v3.09zM83.812 57.326l-.13-.21c.01.13.01.24.01.35v3.35h-.37v-4.75h.01l2.04 2.85 2.05-2.85h.01v4.76h-.37v-3.36c0-.11 0-.22.01-.35-.08.15-.25.37-.37.55l-1.32 1.83-1.57-2.17z" fill="#fff"/></g></g></g></symbol>

                <symbol id="mm-data-item" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg"><circle cx="25" cy="25" r="25" fill="rgb(76,148,166)" /></symbol>
                <symbol id="mm-service-item" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg"><circle cx="25" cy="25" r="25" fill="rgb(232,108,61)"/></symbol>
                <symbol id="mm-feature-item" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg"><circle cx="25" cy="25" r="25" fill="rgb(255,255,255)"/></symbol>
                <symbol id="mm-circle" viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg"><circle cx="250" cy="250" r="250"/></symbol>
              </defs>

              <g className="orbit-tools">
                <title>orbit-tools</title>
              <path id="textcurve-cw" style={{ fill: "none", stroke: " none" }} d="M 450, 500 a 250,250 0 1,1 500,0 a 250,250 0 1,1 -500,0"/>
                <path id="textcurve-ccw" style={{ fill: "none", stroke: " none" }} d="M 450, 500 a 250,250 0 1,0 500,0 a 250,250 0 1,0 -500,0"/>
              </g>

              { block.center_logo && block.center_logo.filename && (
                <g className="space-center-item">
                  <foreignObject width="200" height="200" x="600" y="400">
                    <div className="circle">
                      <img src={block.center_logo.filename} alt={block.center_logo.alt} />
                    </div>
                  </foreignObject>
                </g>
              )}

              <g className="orbit-services">
                <title>orbit-services</title>
                <path style={{ fill: "none" }} className="orbit-path orbit-services-path" d="M 450, 500 a 250,250 0 1,1 500,0 a 250,250 0 1,1 -500,0"/>
              </g>
              <g className="orbit-data">
                <title>orbit-data</title>
                <path style={{ fill: "none" }} className="orbit-path orbit-data-path" d="M 450, 500 a 250,250 0 1,1 500,0 a 250,250 0 1,1 -500,0"/>
              </g>
              <g className="orbit-features">
                <title>orbit-features</title>
                <path style={{ fill: "none" }} className="orbit-path orbit-features-path" d="M 450, 500 a 250,250 0 1,1 500,0 a 250,250 0 1,1 -500,0"/>
              </g>
              <g className="orbit-decoration">
                <title>orbit-decoration</title>
                <path style={{ fill: "none" }} className="orbit-path orbit-decoration-path" d="M 450, 500 a 250,250 0 1,1 500,0 a 250,250 0 1,1 -500,0"/>
              </g>

              <g className="orbit-items">
                {/* <!-- services labels --> */}
                {block.service_orbit_item_text_1 && (
                  <>
                    <text className="orbit-label orbit-label-primary orbit-services-item1-label">{block.service_orbit_item_text_1}</text>
                    <g className="orbit-item orbit-services-item orbit-services-item1">
                      <title>orbit-services-item1</title>
                      <use style={{transform: "scale(0.3)", transformOrigin: "50% 50%" }} href="#mm-service-item" />
                    </g>
                  </>
                )}
                {block.service_orbit_item_text_2 && (
                  <>
                    <text className="orbit-label orbit-label-primary orbit-services-item2-label">{block.service_orbit_item_text_2}</text>
                    <g className="orbit-item orbit-services-item orbit-services-item2">
                      <title>orbit-services-item2</title>
                      <use style={{transform: "scale(0.3)", transformOrigin: "50% 50%" }} href="#mm-service-item" />
                    </g>
                  </>
                )}
                {block.service_orbit_item_text_3 && (
                  <>
                    <text className="orbit-label orbit-label-primary orbit-services-item3-label">{block.service_orbit_item_text_3}</text>
                    <g className="orbit-item orbit-services-item orbit-services-item3">
                      <title>orbit-services-item3</title>
                      <use style={{transform: "scale(0.3)", transformOrigin: "50% 50%" }} href="#mm-service-item" />
                    </g>
                  </>
                )}
                {block.service_orbit_item_text_4 && (
                  <>
                    <text className="orbit-label orbit-label-primary orbit-services-item4-label">{block.service_orbit_item_text_4}</text>
                    <g className="orbit-item orbit-services-item orbit-services-item3">
                      <title>orbit-services-item3</title>
                      <use style={{transform: "scale(0.3)", transformOrigin: "50% 50%" }} href="#mm-service-item" />
                    </g>
                  </>
                )}

                {/* <!-- feature labels --> */}
                <g className="orbit-features-labels">
                  {block.features_orbit_item_text_1 && (
                    <>
                      <g className="orbit-features-item1-label-g">
                        <text className="orbit-label orbit-label-secondary orbit-features-item1-label" style={{ opacity: 1 }}>
                          <textPath xlinkHref="#textcurve-cw">
                            {block.features_orbit_item_text_1}
                          </textPath>
                        </text>
                      </g>
                      <g className="orbit-features-fragment orbit-features-fragment-1">
                        <use href="#mm-circle" />
                      </g>
                    </>
                  )}
                  {block.features_orbit_item_text_2 && (
                    <>
                      <g className="orbit-features-item2-label-g">
                        <text className="orbit-label orbit-label-secondary orbit-features-item2-label" style={{ opacity: 1 }}>
                          <textPath xlinkHref="#textcurve-cw">
                            {block.features_orbit_item_text_2}
                          </textPath>
                        </text>
                      </g>
                      <g className="orbit-features-fragment orbit-features-fragment-2">
                        <use href="#mm-circle" />
                      </g>
                    </>
                  )}
                  {block.features_orbit_item_text_3 && (
                    <>
                      <g className="orbit-features-item3-label-g">
                        <text className="orbit-label orbit-label-secondary orbit-features-item3-label" dy="10" style={{ opacity: 1 }}>
                          <textPath xlinkHref="#textcurve-ccw">
                            {block.features_orbit_item_text_3}
                          </textPath>
                        </text>
                      </g>
                      <g className="orbit-features-fragment orbit-features-fragment-3">
                        <use href="#mm-circle" />
                      </g>
                    </>
                  )}
                  {block.features_orbit_item_text_4 && (
                    <>
                      <g className="orbit-features-item4-label-g">
                        <text className="orbit-label orbit-label-secondary orbit-features-item4-label" dy="10" style={{ opacity: 1 }}>
                          <textPath xlinkHref="#textcurve-ccw">
                            {block.features_orbit_item_text_4}
                          </textPath>
                        </text>
                      </g>
                      <g className="orbit-features-fragment orbit-features-fragment-4">
                        <use href="#mm-circle" />
                      </g>
                    </>
                  )}
                </g>

                <g className="orbit-features-items">
                  {block.features_orbit_item_text_1 && (
                    <g className="orbit-item orbit-features-item orbit-features-item1">
                      <title>orbit-features-item1</title>
                      <use style={{ transform: "scale(0.2)", transformOrigin: "50% 50%" }} href="#mm-feature-item" />
                    </g>
                  )}
                  {block.features_orbit_item_text_2 && (
                    <g className="orbit-item orbit-features-item orbit-features-item2">
                      <title>orbit-features-item2</title>
                      <use style={{transform: "scale(0.2)", transformOrigin: "50% 50%" }} href="#mm-feature-item" />
                    </g>
                  )}
                  {block.features_orbit_item_text_3 && (
                    <g className="orbit-item orbit-features-item orbit-features-item3">
                      <title>orbit-features-item3</title>
                      <use style={{ transform: "scale(0.2)", transformOrigin: "50% 50%" }} href="#mm-feature-item" />
                    </g>
                  )}
                  {block.features_orbit_item_text_4 && (
                    <g className="orbit-item orbit-features-item orbit-features-item4">
                      <title>orbit-features-item3</title>
                      <use style={{ transform: "scale(0.2)", transformOrigin: "50% 50%" }} href="#mm-feature-item" />
                    </g>
                  )}
                </g>


                {block.data_orbit_item_text_1 && (
                  <>
                    <text className="orbit-label orbit-label-primary orbit-data-item1-label">{block.data_orbit_item_text_1}</text>
                    <g className="orbit-item orbit-data-item orbit-data-item1">
                      <title>orbit-data-item1</title>
                      <use style={{transform: "scale(0.3)", transformOrigin: "50% 50%" }} href="#mm-data-item" />
                    </g>
                  </>
                )}
                {block.data_orbit_item_text_2 && (
                  <>
                  <text className="orbit-label orbit-label-primary orbit-data-item2-label">{block.data_orbit_item_text_2.split(" ").map((word) => { return (<tspan key={word} x="0" dy="1.2em">{word}</tspan>) })}</text>
                    <g className="orbit-item orbit-data-item orbit-data-item2">
                      <title>orbit-data-item2</title>
                      <use style={{transform: "scale(0.3)", transformOrigin: "50% 50%" }} href="#mm-data-item" />
                    </g>
                  </>
                )}
                {block.data_orbit_item_text_3 && (
                  <>
                    <text className="orbit-label orbit-label-primary orbit-data-item3-label" transform="translate(-100 0)">{block.data_orbit_item_text_3.split(" ").map((word) => { return (<tspan key={word} x="100%" textAnchor="end" dy="1.2em">{word}</tspan>) })}</text>
                    <g className="orbit-item orbit-data-item orbit-data-item3">
                      <title>orbit-data-item3</title>
                      <use style={{transform: "scale(0.3)", transformOrigin: "50% 50%" }} href="#mm-data-item" />
                    </g>
                  </>
                )}
                {block.data_orbit_item_text_4 && (
                  <>
                    <text className="orbit-label orbit-label-primary orbit-data-item4-label">{block.data_orbit_item_text_4}</text>
                    <g className="orbit-item orbit-data-item orbit-data-item4">
                      <title>orbit-data-item4</title>
                      <use style={{transform: "scale(0.3)", transformOrigin: "50% 50%" }} href="#mm-data-item" />
                    </g>
                  </>
                )}
              </g>
            </svg>
          </div>
      </div>
    </div>
  )
}

export default Orbit
